import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { DispatchWithPolicePrivilege } from "models/account";
import { RouteName } from "constants/route";

export default function DispatchWithPolicyGuard() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return <Navigate to={RouteName.LOGIN} />;
    
    const role = (jwtDecode(token) as any).role;
    if (DispatchWithPolicePrivilege.includes(role)) return <Outlet />;
    else return <Navigate to={RouteName.LOGIN} />;
  } catch (error) {
    console.error("Error decoding token in DispatchWithPolicyGuard:", error);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    return <Navigate to={RouteName.LOGIN} />;
  }
}
